import type { LibraryItem } from '../../api';
import { LIBRARY_FIELDS, POSITION_TYPES } from '../../format';
import type { DetailField } from '../../ui/detailForm';

const KIND_LABELS: Record<LibraryItem['kind'], string> = { title: 'Titel', position: 'Position', note: LIBRARY_FIELDS.note.label };

/**
 * An entry of a text library in the detail popup (AP-128): what the inline
 * cells and the long-text dialog used to change, in one place. Unit and kind
 * of position belong to positions, a long text to positions and notes.
 */
export function libraryItemFields(item: LibraryItem): DetailField[] {
  const position = item.kind === 'position';
  return [
    { key: 'kind', label: 'Art des Eintrags', value: KIND_LABELS[item.kind] },
    { key: 'oz', label: LIBRARY_FIELDS.oz.label, value: item.oz, mono: true },
    { key: 'shortText', label: LIBRARY_FIELDS.shortText.label, value: item.shortText, edit: 'text', required: true },
    ...(position ? [
      { key: 'unit', label: LIBRARY_FIELDS.unit.label, value: item.unit, edit: 'text' },
      {
        key: 'positionType', label: LIBRARY_FIELDS.positionType.label, raw: item.positionType,
        value: POSITION_TYPES.find((t) => t.value === item.positionType)?.label ?? item.positionType,
        edit: { options: POSITION_TYPES.map((t) => ({ value: t.value, label: t.label })) },
      },
    ] satisfies DetailField[] : []),
    { key: 'source', label: LIBRARY_FIELDS.source.label, value: item.source, edit: 'text' },
    { key: 'attribution', label: LIBRARY_FIELDS.attribution.label, value: item.attribution, edit: 'text' },
    ...(item.kind !== 'title' ? [{ key: 'longText', label: LIBRARY_FIELDS.longText.label, value: item.longText, long: true, edit: 'textarea' }] satisfies DetailField[] : []),
  ];
}
